import type { FileItem } from '_atoms/File/types';
import type { CandidateDocument } from 'store/reducers/candidateReducer';
import type { Uuid } from 'store/reducers/types';

export const candidateDocumentToFileItem = (doc: Uuid | CandidateDocument): (FileItem & { uuid: string }) | null => {
  if (typeof doc === 'string' || !doc.file || !doc.filename) return null;
  return {
    uuid: doc.uuid,
    file: doc.file,
    filename: doc.filename,
    uploaded: doc.uploaded ?? '',
    link: typeof doc.link === 'boolean' ? doc.link : undefined,
  };
};
